export default __webpack_public_path__ + "static/media/someplant.4ef5095a.png";